// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/optimism-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RPCRequest } from './RPCRequest';
import {
    RPCRequestFromJSON,
    RPCRequestFromJSONTyped,
    RPCRequestToJSON,
} from './RPCRequest';
import type { RPCResponseId } from './RPCResponseId';
import {
    RPCResponseIdFromJSON,
    RPCResponseIdFromJSONTyped,
    RPCResponseIdToJSON,
} from './RPCResponseId';

/**
 * jsonrpc request or batch requests
 * @export
 * @interface DoRpcRequestRequest
 */
export interface DoRpcRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DoRpcRequestRequest
     */
    jsonrpc: DoRpcRequestRequestJsonrpcEnum;
    /**
     * 
     * @type {RPCResponseId}
     * @memberof DoRpcRequestRequest
     */
    id: RPCResponseId;
    /**
     * 
     * @type {string}
     * @memberof DoRpcRequestRequest
     */
    method: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof DoRpcRequestRequest
     */
    params?: Array<any>;
}


/**
 * @export
 */
export const DoRpcRequestRequestJsonrpcEnum = {
    _20: '2.0'
} as const;
export type DoRpcRequestRequestJsonrpcEnum = typeof DoRpcRequestRequestJsonrpcEnum[keyof typeof DoRpcRequestRequestJsonrpcEnum];


/**
 * Check if a given object implements the DoRpcRequestRequest interface.
 */
export function instanceOfDoRpcRequestRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jsonrpc" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function DoRpcRequestRequestFromJSON(json: any): DoRpcRequestRequest {
    return DoRpcRequestRequestFromJSONTyped(json, false);
}

export function DoRpcRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoRpcRequestRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jsonrpc': json['jsonrpc'],
        'id': RPCResponseIdFromJSON(json['id']),
        'method': json['method'],
        'params': !exists(json, 'params') ? undefined : json['params'],
    };
}

export function DoRpcRequestRequestToJSON(value?: DoRpcRequestRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jsonrpc': value.jsonrpc,
        'id': RPCResponseIdToJSON(value.id),
        'method': value.method,
        'params': value.params,
    };
}

